import { render, staticRenderFns } from "./ReaderSelect.vue?vue&type=template&id=7b63018d&"
import script from "./ReaderSelect.vue?vue&type=script&lang=js&"
export * from "./ReaderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports